<template>
  <div class="onboarding">
    <onboarding-wizard   
      @generate-cv="onGenerateCV"
      @finish="onFinish"/>
  </div>
</template>

<script>
//import Icon from '@/components/common/Icon.vue';
import OnboardingWizard from '@/components/onboarding/OnboardingWizard.vue';

export default {
  name: 'Onboarding',
  components: {
    OnboardingWizard,
  },
  computed: {
    userContactInfo() {
      return this.$store.state.user.userContactInfo;
    },
  },
  mounted() {
    document.title = 'AllTeams Onboarding';
    // Ensure userContactInfo is loaded
    if (!this.userContactInfo) {
      this.$store.dispatch('GET_USER_CONTACT_INFO');
    }
  },
  methods: {
    // Called when you press "Next" on the notes step
    onGenerateCV(payload) {
      //console.log('CV payload:', payload)
    },

    // Called when onboarding is finished
    onFinish() {
      console.log("Onboarding closed, navigating to home")
      this.$router.push({ name: 'Home' }) // or path: '/' if you prefer
    },

  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/shared/_globals.scss';

.onboarding {
  &__newsfeed {
  }

  &__add-new {
    width: 100%;
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    margin-bottom: var(--global-dimension-size-400);

    cursor: pointer;
    padding: 14px 20px;
    box-sizing: border-box;

    color: var(--color-primary-400);
    background-color: var(--color-gray-200);
    border-radius: var(--border-radius-base);

    &:hover {
      background-color: var(--color-gray-300);
    }
  }

  &__add-new-label {
    font-weight: 500;
    margin-left: 16px;
  }
}

.news-item {
  margin-bottom: 20px;
  background-color: var(--color-gray-50);
  padding: var(--global-dimension-size-250);
  border-radius: var(--border-radius-base);

  &__header {
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: var(--global-dimension-size-250);
  }

  &__avatar {
    margin-right: var(--global-dimension-size-200);
  }

  &__header-info {
    line-height: 1.6;
  }

  &__name {
    font-weight: 500;
    font-size: var(--font-size-300);
  }

  &__date {
    font-size: var(--font-size-100);
    color: var(--color-gray-800);
  }

  &__photo {
    display: block;
    max-width: 100%;
    margin-bottom: var(--global-dimension-size-250);
  }

  &__title {
    font-weight: 500;
    font-size: var(--font-size-300);
    line-height: 1.6;
    margin-bottom: var(--global-dimension-size-125);
  }

  &__text {
    line-height: 1.6;
  }

  &__bottom {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-top: var(--global-dimension-size-250);
  }

  &__likes {
    display: flex;
    align-items: center;
    margin-right: var(--global-dimension-size-300);
    cursor: not-allowed;
  }

  &__likes-count {
    margin-left: var(--global-dimension-size-125);
  }

  &__share {
    cursor: not-allowed;
    line-height: 1;
  }

  &__pagination {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-top: var(--global-dimension-size-250);
    align-items: center;
  }
}
</style>
